<template>
  <div>
    <section class="bar-top-page px-4">
      <div class="bar-top-page-row">
        <div class="bar-top-page-left">
          <h3 class="h3 text-primary font-semi-bold m-0">
            Historial de Suscripciones
          </h3>
        </div>
      </div>
    </section>

    <b-container fluid class="pb-4 px-lg-4">
      <template v-if="apiResponse.success">
        <section class="input-filters">
          <InputSearchComponent @onChangeSearch="onChangeSearch" />
          <SelectOrderByComponent
            defaultValue="recent"
            @onSelectOrderBy="onSelectOrderBy"
          />
        </section>

        <section class="wrapper__content-sale-document">
          <paginate
            class="wrapper-pagination"
            name="resultQuerySubscriptions"
            :list="resultQuerySubscriptions"
            :per="perPaginate"
            :key="searchQuery"
          >
            <!-- Desktop: Tabla clásica -->
            <div class="history-table d-none d-lg-block">
              <div class="history-table-header">
                <span>Suscripción</span>
                <span>Período</span>
                <span>Total</span>
                <span>Estado</span>
                <span></span>
              </div>
              <div
                class="history-table-row"
                v-for="(subscription, index) in paginated(
                  'resultQuerySubscriptions'
                )"
                :key="'table-' + index"
              >
                <span class="history-td-name">
                  {{ getPlanLabel(subscription) }}
                </span>
                <span class="history-td-period">
                  <template v-if="subscription.type === 'order'">
                    <span class="history-order-ref"
                      >Orden #{{ subscription.order_number }}</span
                    >
                  </template>
                  <template v-else>
                    {{ subscription.starts_at }} – {{ subscription.ends_at }}
                  </template>
                </span>
                <span class="history-td-amount">
                  ${{ subscription.total }}
                </span>
                <span class="history-td-status">
                  <span
                    class="history-status-badge"
                    :class="getStatusClass(subscription)"
                  >
                    {{ getStatusLabel(subscription) }}
                  </span>
                </span>
                <span class="history-td-actions" @click.stop>
                  <MoreOptions
                    :options="options"
                    @optionSelected="
                      option => optionSelected(option, subscription)
                    "
                  />
                </span>
              </div>
            </div>

            <!-- Mobile/Tablet: Cards -->
            <div class="d-lg-none">
              <div
                class="sale-document-body md__border border-radius bg-color-write p-3 mb-2"
                v-for="(subscription, index) in paginated(
                  'resultQuerySubscriptions'
                )"
                :key="'card-' + index"
              >
                <div class="sale-document-info">
                  <div
                    class="sale-document-description d-flex justify-content-between"
                  >
                    <div class="info">
                      <p
                        class="m-0 font-bold text-color-primary str-limit-space"
                      >
                        {{ getPlanLabel(subscription) }}
                      </p>
                      <p class="m-0">
                        <small class="text-color-black">
                          <template v-if="subscription.type === 'order'">
                            Orden #{{ subscription.order_number }}
                          </template>
                          <template v-else>
                            {{ subscription.starts_at }} -
                            {{ subscription.ends_at }}
                          </template>
                        </small>
                      </p>
                    </div>
                    <div class="sale-document-number">
                      <h5 class="h5 font-bold">${{ subscription.total }}</h5>
                    </div>
                  </div>
                </div>
                <div
                  class="sale-document-actions d-flex justify-content-between align-items-center mt-2"
                >
                  <div class="status d-flex align-items-center">
                    <span
                      class="history-status-badge"
                      :class="getStatusClass(subscription)"
                    >
                      {{ getStatusLabel(subscription) }}
                    </span>
                  </div>
                  <div class="next" @click.stop>
                    <MoreOptions
                      :options="options"
                      @optionSelected="
                        option => optionSelected(option, subscription)
                      "
                    />
                  </div>
                </div>
              </div>
            </div>
          </paginate>

          <div
            v-if="resultQuerySubscriptions.length === 0"
            class="text-center py-5"
          >
            <i
              class="el-icon-document"
              style="font-size: 48px; color: #d5d5d5;"
            ></i>
            <p class="mt-3" style="color: #989aae;">
              No se encontraron suscripciones
            </p>
          </div>

          <paginate-links
            v-show="resultQuerySubscriptions.length > perPaginate"
            for="resultQuerySubscriptions"
            :classes="{
              ul: 'pagination',
              li: 'page-item',
              a: 'page-link'
            }"
            :simple="{
              next: 'Siguiente »',
              prev: '« Regresar'
            }"
          ></paginate-links>
        </section>
      </template>
      <LoadingSkeletonTable v-else />
    </b-container>
  </div>
</template>

<script>
import InputSearchComponent from "../../components/InputSearch";
import SelectOrderByComponent from "../../components/SelectOrderBy";
import LoadingSkeletonTable from "@/components/Animations/Loading/SkeletonTable";
import MoreOptions from "../../components/MoreOptions";

import payService from "../services/payService";
import { downloadFile } from "@/assets/utils/files";

export default {
  name: "PlanHistoryComponent",
  data: () => ({
    apiResponse: {
      success: false
    },
    searchQuery: null,
    orderByQuery: "recent",
    perPaginate: 10,
    paginate: ["resultQuerySubscriptions"],
    subscriptions: [],
    options: [
      {
        key: "download",
        label: "Descargar factura"
      }
    ]
  }),
  computed: {
    resultQuerySubscriptions() {
      let subscriptions = this.subscriptions;
      return subscriptions
        .concat()
        .sort((a, b) => {
          switch (this.orderByQuery) {
            case "recent":
              return a.id < b.id ? 1 : -1;
            case "old":
              return a.id > b.id ? 1 : -1;
            case "a-z":
              return a.description.toLowerCase() < b.description.toLowerCase()
                ? -1
                : 1;
            case "z-a":
              return a.description.toLowerCase() > b.description.toLowerCase()
                ? -1
                : 1;
          }
        })
        .filter(item =>
          this.searchQuery
            ? item.description
                .toLowerCase()
                .includes(this.searchQuery.toLowerCase())
            : item
        );
    }
  },
  methods: {
    toggleApiResponse(property, value) {
      this.apiResponse[property] = value;
    },
    onChangeSearch({ search }) {
      this.searchQuery = search;
    },
    onSelectOrderBy({ orderBy }) {
      this.orderByQuery = orderBy;
    },
    optionSelected({ option }, subscription) {
      switch (option) {
        case "download":
          this.downloadInvoiceSubscription(subscription);
          break;
      }
    },
    async getSubscriptions() {
      try {
        let response = await payService.getSubscriptions();
        const { success, data } = response.data;
        if (success) {
          this.subscriptions = data;
          this.toggleApiResponse("success", true);
        }
      } catch (error) {
        return false;
      }
    },
    getStatusClass(subscription) {
      if (subscription.type === "order") {
        return subscription.status === "rejected"
          ? "history-status-badge--rejected"
          : "history-status-badge--pending";
      }
      return subscription.active
        ? "history-status-badge--active"
        : "history-status-badge--expired";
    },
    getStatusLabel(subscription) {
      if (subscription.type === "order") {
        return subscription.status === "rejected" ? "Rechazada" : "En espera";
      }
      return subscription.active ? "Activa" : "Vencida";
    },
    getPlanLabel(subscription) {
      // Use plan relation if available
      if (subscription.plan) {
        const name =
          subscription.plan.display_name ||
          (typeof subscription.plan.name === "string"
            ? subscription.plan.name
            : null);
        if (name) {
          const hasFirma =
            subscription.description &&
            subscription.description.includes("&firma");
          return hasFirma ? `${name} + Firma electrónica` : name;
        }
      }
      // Fallback to legacy slug-based description
      return this.getDesctiptionPlan(subscription.description) || "Suscripción";
    },
    getDesctiptionPlan(slug) {
      let cadena = [];
      if (slug) {
        cadena = slug?.split("&");
      }
      let title =
        this.$store.getters.getPlans.find(p => p.slug === cadena[0])
          ?.description || slug;

      return cadena.length > 1 ? `${title} Con Firma Electr\u00f3nica` : title;
    },
    async downloadInvoiceSubscription({
      id: subscriptionId,
      description,
      has_payments
    }) {
      if (!has_payments) {
        this.$notifications.warning({
          message: "Factura no disponible"
        });
        return false;
      }
      try {
        this.$store.dispatch("toggleRequestLoading");
        let response = await payService
          .downloadInvoiceSubscription(subscriptionId)
          .finally(() => {
            this.$store.dispatch("toggleRequestLoading");
          });
        const { data } = response;
        if (data) {
          downloadFile(data, `${description}`);
        }
      } catch (error) {
        return false;
      }
    }
  },
  components: {
    InputSearchComponent,
    SelectOrderByComponent,
    LoadingSkeletonTable,
    MoreOptions
  },
  mounted() {
    this.getSubscriptions();
  }
};
</script>

<style lang="scss" scoped>
$bg: #f7f8f9;
$border: #ebeef5;
$primary: #2d2b55;

// Desktop table
.history-table {
  background: #fff;
  border: 1px solid $border;
  border-radius: 10px;
  overflow: hidden;
}

.history-table-header {
  display: grid;
  grid-template-columns: 1fr 200px 100px 110px 50px;
  align-items: center;
  gap: 8px;
  padding: 10px 20px;
  background: $bg;
  border-bottom: 1px solid $border;
  font-size: 11px;
  font-weight: 700;
  color: #909399;
  text-transform: uppercase;
  letter-spacing: 0.3px;
}

.history-table-row {
  display: grid;
  grid-template-columns: 1fr 200px 100px 110px 50px;
  align-items: center;
  gap: 8px;
  padding: 12px 20px;
  border-bottom: 1px solid $border;
  font-size: 13px;
  color: #303133;
  transition: background 0.12s;

  &:last-child {
    border-bottom: none;
  }

  &:hover {
    background: $bg;
  }
}

.history-td-name {
  font-weight: 600;
  color: $primary;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.history-td-period {
  font-size: 12px;
  color: #909399;
}

.history-td-amount {
  font-weight: 600;
  color: $primary;
}

.history-td-status {
  display: flex;
  align-items: center;
}

.history-td-actions {
  display: flex;
  justify-content: center;
}

// Status badges
.history-status-badge {
  display: inline-block;
  padding: 3px 10px;
  border-radius: 20px;
  font-size: 11px;
  font-weight: 600;

  &--active {
    background: #e4fff4;
    color: #1d9e75;
  }

  &--expired {
    background: #fff0f0;
    color: #f56c6c;
  }

  &--pending {
    background: #fff8e6;
    color: #e6a817;
  }

  &--rejected {
    background: #fff0f0;
    color: #f56c6c;
  }
}

.history-order-ref {
  font-size: 12px;
  color: #909399;
}
</style>
